// 割引表示の期間設定
export const startDate = new Date('2025-03-20T00:00:00+09:00'); // 2024/09/14 0:00 JST
//export const startDate = new Date('2024-11-26T00:00:00+09:00'); // 2024/09/14 0:00 JST
export const endDate = new Date('2025-04-21T00:00:00+09:00');   // 2024/10/14 0:00 JST
export const discountCampaignCode = 'Spring 2025';
export const popupImageUrl = 'https://www.eltschool.jp/wp-content/uploads/2025/03/popup-spring25.png';
export const popupLinkUrl = 'https://www.eltschool.jp/lp/spring2025';
export const campaignTitle = "春の応援";
